var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, MessageBanner, Modal } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { changeDepositRecordStatus } from "../../api/enforcementService";
import { RecordHistory } from "./RecordHistory";
import { DepositRecordStatusBadge, LIBRARY_STATUS_BY_ACTION, LibraryStatusChoice, actionForStatus, } from "./statusChoice";
import css from "./DepositRecordStatusDialog.module.css";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
export var DepositRecordStatusDialog = function (_a) {
    var record = _a.record, onClose = _a.onClose, onStatusChanged = _a.onStatusChanged;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _b = useState(null), selectedAction = _b[0], setSelectedAction = _b[1];
    var _c = useState(false), historyOpen = _c[0], setHistoryOpen = _c[1];
    var _d = useState(null), errorMessage = _d[0], setErrorMessage = _d[1];
    useEffect(function () {
        setSelectedAction(null);
        setHistoryOpen(false);
        setErrorMessage(null);
    }, [record]);
    var statusMutation = useMutation(function (_a) {
        var recordId = _a.recordId, status = _a.status;
        return changeDepositRecordStatus(kyInstance, recordId, { status: status });
    }, {
        onSuccess: function () {
            invalidateDepositRecordViews(queryClient);
            onStatusChanged();
            onClose();
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var fallback, data, firstError, backendCode, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        fallback = formatMessage({
                            id: "ui-br-legaldeposits.enforcement.statusDialog.error",
                        });
                        if (!(error !== null &&
                            typeof error === "object" &&
                            "response" in error)) return [3 /*break*/, 4];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, error.response.json()];
                    case 2:
                        data = _c.sent();
                        firstError = (_b = data === null || data === void 0 ? void 0 : data.errors) === null || _b === void 0 ? void 0 : _b[0];
                        backendCode = firstError === null || firstError === void 0 ? void 0 : firstError.code;
                        setErrorMessage(backendCode
                            ? formatMessage({
                                id: "ui-br-legaldeposits.enforcement.statusDialog.error.".concat(backendCode),
                                defaultMessage: (firstError === null || firstError === void 0 ? void 0 : firstError.message) || fallback,
                            })
                            : (firstError === null || firstError === void 0 ? void 0 : firstError.message) || fallback);
                        return [2 /*return*/];
                    case 3:
                        _a = _c.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        setErrorMessage(fallback);
                        return [2 /*return*/];
                }
            });
        }); },
    });
    if (!record)
        return null;
    var currentAction = actionForStatus(record.status);
    var handleConfirm = function () {
        if (!selectedAction)
            return;
        statusMutation.mutate({
            recordId: record.id,
            status: LIBRARY_STATUS_BY_ACTION[selectedAction],
        });
    };
    return (React.createElement(Modal, { open: true, dismissible: true, onClose: onClose, label: formatMessage({
            id: "ui-br-legaldeposits.enforcement.statusDialog.title",
        }), footer: React.createElement("div", null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleConfirm, disabled: statusMutation.isLoading ||
                    !selectedAction ||
                    selectedAction === currentAction },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.confirm" })),
            React.createElement(Button, { onClick: onClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement("div", { className: css.statusLine },
            React.createElement("span", { className: css.statusLineLabel },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.statusDialog.current-status" })),
            React.createElement(DepositRecordStatusBadge, { status: record.status })),
        currentAction ? (React.createElement(LibraryStatusChoice, { currentStatus: record.status, selected: selectedAction, onSelect: function (action) { return function () { return setSelectedAction(action); }; } })) : (React.createElement(MessageBanner, { type: "default" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.statusDialog.no-actions-available" }))),
        React.createElement("div", { className: css.historyBlock },
            React.createElement(Button, { onClick: function () { return setHistoryOpen(function (open) { return !open; }); }, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.action.history" })),
            historyOpen && React.createElement(RecordHistory, { recordId: record.id })),
        errorMessage && (React.createElement(MessageBanner, { type: "error" }, errorMessage))));
};
